import NavBar from "../components/navbar";
import Footer from "../components/footer";
import {
  CalendarIcon,
  LocationMarkerIcon,
  UsersIcon,
} from "@heroicons/react/solid";
import { useEffect, useState } from "react";

import { topicListApi } from "../services/topic";

export type TopicList = {
  id: number;
  topicTitle: string;
  topicDesc: string;
};

const Home = () => {
  const [topics, setTopics] = useState<TopicList[]>();

  useEffect(() => {
    const loadTopicList = async () => {
      const topicLists = await topicListApi();
      if (topicLists) {
        setTopics(topicLists.topics);
      }
    };
    loadTopicList();
  }, []);

  return (
    <>
      <NavBar />
      {/* <div className="grid h-screen place-items-center">
        Welcome To Home Page
      </div> */}

      <div className="grid h-screen place-items-center">
        <div className="bg-white shadow overflow-hidden sm:rounded-md w-5/6">
          <ul role="list" className="divide-y divide-gray-200">
            {topics && topics.map((topic) => (
              <li key={topic.id}>
                <div className="px-4 py-4 sm:px-6">
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-medium text-indigo-600 truncate">
                      <a
                        href={`/forum/${topic.id}`}
                        className="block hover:bg-gray-50"
                      >
                        {topic.topicTitle}
                      </a>
                    </p>
                    {/* <div className="ml-2 flex-shrink-0 flex">
                      <p className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                        {topic.type}
                      </p>
                    </div> */}
                  </div>

                  <div className="mt-2 sm:flex sm:justify-between">
                    <div className="sm:flex">
                      <p className="flex items-center text-sm text-gray-500">
                        <UsersIcon
                          className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                        {topic.topicDesc}
                      </p>
                      {/* <p className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6">
                        <LocationMarkerIcon
                          className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                        {position.location}
                      </p> */}
                    </div>

                    {/* <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                      <CalendarIcon
                        className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                      <p>
                        Closing on{" "}
                        <time dateTime={position.closeDate}>
                          {position.closeDateFull}
                        </time>
                      </p>
                    </div> */}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Home;
